import React from 'react';
import { Star, ShieldCheck, ArrowRight } from 'lucide-react';
import { Volleyball } from './Volleyball';
import { ChalkboardPattern } from './ChalkboardPattern';
export function Hero() {
  return <section className="relative bg-pilates-blue-dark overflow-hidden pt-5 pb-10 sm:pt-10 sm:pb-16 px-4 sm:px-6 lg:px-8 border-t border-b border-pilates-lavender" data-id="element-132">
      <ChalkboardPattern className="text-white opacity-[0.06]" data-id="element-133" />

      <div className="relative max-w-3xl mx-auto flex flex-col items-center text-center z-10" data-id="element-134">
        <div className="flex items-center gap-2 mb-3 sm:mb-6 border-b border-pilates-lavender pb-1" data-id="element-135">
          <Volleyball className="w-4 h-4 sm:w-5 sm:h-5 text-pilates-cream" data-id="element-136" />
          <span className="font-display font-semibold text-white text-base sm:text-lg tracking-[0.25em] uppercase" data-id="element-137">
            VOLLEY READY
          </span>
        </div>

        <div className="border border-pilates-lavender text-pilates-lavender font-semibold text-[10px] sm:text-sm px-3 sm:px-4 py-1 sm:py-1.5 mb-4 sm:mb-8 flex items-center gap-2 tracking-wider uppercase" data-id="element-138">
          ✨ VALIDATED TRAINING METHODOLOGY
        </div>

        <div className="w-10 h-[2px] bg-pilates-lavender mb-4 sm:mb-6" data-id="element-139"></div>

        <h1 className="font-display sm:text-5xl md:text-6xl font-semibold text-white leading-[1.15] sm:leading-[1.05] mb-3 sm:mb-6 tracking-tight ml-[15px] text-[28px]" data-id="element-140">
          The All-In-One Planning System for{' '}
          <span className="italic text-pilates-lavender" data-id="element-141">Volleyball</span>{' '}
          Coaches
        </h1>

        <p className="text-sm sm:text-lg text-white/85 max-w-xl mb-5 sm:mb-10 leading-relaxed px-2 sm:px-0" data-id="element-142">
          Save time, regain your peace of mind, and elevate your team's
          performance — without the burnout of manual planning.
        </p>

        <div className="mb-5 sm:mb-10 max-w-[230px] sm:max-w-md mx-auto w-full" data-id="element-143">
          <img src="https://cdn.magicpatterns.com/uploads/3BeFdoayiknhsrXtc74pGh/image_(3).webp" alt="VolleyReady 6-in-1 Bundle" className="w-full rounded-2xl shadow-2xl" fetchPriority="high" decoding="async" width="800" height="800" data-id="element-144" />
        </div>

        <a href="#pricing-card" className="group relative inline-flex items-center justify-center gap-2 sm:gap-3 bg-gradient-to-r from-pilates-rose to-pilates-rose-dark text-white font-semibold text-sm sm:text-lg py-3 sm:py-4 px-6 sm:px-12 rounded-lg border-t border-white/20 shadow-[0_10px_30px_rgba(192,57,43,0.35)] hover:shadow-[0_15px_40px_rgba(192,57,43,0.5)] hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto pt-[20px] pb-[20px]" data-id="element-145">
          <span data-id="element-146">🏐 Get My Coaching System Now</span>
          <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" data-id="element-147" />
        </a>

        <div className="mt-4 sm:mt-6 flex flex-col items-center gap-1.5 sm:gap-2" data-id="element-148">
          <div className="flex items-center gap-2" data-id="element-149">
            <div className="flex text-pilates-lavender" data-id="element-150">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="currentColor" data-id="element-151" />)}
            </div>
            <span className="text-white/90 text-xs sm:text-sm font-medium" data-id="element-152">
              4.9/5 — Verified Coach Reviews
            </span>
          </div>
          <div className="flex items-center gap-2 text-white/80 text-xs sm:text-sm" data-id="element-153">
            <ShieldCheck className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-pilates-lavender" data-id="element-154" />
            <span data-id="element-155">30-Day Money Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}